<template>
  <div class="box" flex-1>
    <el-card class="box-card" flexContainer :body-style="{ padding:'0 30px' }">
      <div class="header">
        <div></div>
        <el-button type="primary" icon="el-icon-plus" class="addadmin" @click="addRole">添加角色</el-button>
      </div>
      <el-table
        flex-1
        :data="tableData"
        style="width: 100%"
        :header-cell-style="headerClass"
        :height="real_height + 'px'"
        :row-class-name="class_name"
      >
        <el-table-column width="60">
          <template>
            <span></span>
          </template>
        </el-table-column>
        <el-table-column label="角色名称" class="table_head">
          <template slot-scope="scope">
            <span class="table_content">{{ scope.row.roleName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="当前分配用户数" class="table_head">
          <template slot-scope="scope">
            <span class="table_content">{{ scope.row.count }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="权限包含" class="table_head">
          <template slot-scope="scope">
            <span class="limit table_content" @click="lookLimit(scope.row.roleId)">点击查看</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" class="table_head">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">编辑角色</el-button>
            <el-button
              size="mini"
              type="text"
              class="del_button"
              @click="handleDelete(scope.$index, scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <addactor v-on:addactor="getRoleFun" ref="addrole" @updateInfo="getRoleFun"></addactor>
      <setactor v-on:setactor="getRoleFun" ref="setrole"></setactor>
      <limits ref="limit"></limits>
      <noclose ref="notClose"></noclose>
    </el-card>
  </div>
</template>

<script>
import { getRole, deleteRole } from "../../api/index";
export default {
  components: {
    // 添加角色
    addactor: () =>
      import(/* webpackChunkName: "design" */ "./components/addActor"),
    // 修改角色
    setactor: () =>
      import(/* webpackChunkName: "design" */ "./components/setActor"),
    // 查看权限
    limits: () =>
      import(/* webpackChunkName: "design" */ "./components/limits"),
    // 无法删除
    noclose: () =>
      import(/* webpackChunkName: "design" */ "./components/noclose")
  },
  data() {
    return {
      options: [],
      tableData: [],
      value: "",
      org_height: document.documentElement.clientHeight,
      real_height: document.documentElement.clientHeight - 170,
      timer: false
    };
  },
  mounted() {
    this.real_height = this.org_height - 170;
    const that = this;
    window.addEventListener("resize", function() {
      that.org_height = document.documentElement.clientHeight;
    });
    this.getRoleFun();
  },
  watch: {
    org_height(val) {
      if (!this.timer) {
        this.real_height = val - 170;
        this.timer = true;
        let that = this;
        setTimeout(function() {
          that.timer = false;
        }, 400);
      }
    }
  },
  // mounted() {
  //   this.getRoleFun();
  // },
  methods: {
    class_name({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "popularLine";
      } else {
        return "colorLine";
      }
    },
    //table表头
    headerClass() {
      return "background-color:#FAFCFF;height:32px;padding:5px";
    },
    //获得角色列表
    getRoleFun() {
      getRole()
        .then(res => {
          this.tableData = res.data;
        })
        .catch(error => {});
    },
    // 添加角色组件初始化
    addRole() {
      this.$refs.addrole.init();
    },
    // 修改角色组初始化
    handleEdit(id, data) {
      this.$refs.setrole.init(id, data);
    },
    // 删除角色组件初始化
    handleDelete(id, role) {
      // 判断该角色是否已应用
      if (role.count == 0) {
        this.$confirm("您确定要删除这角色吗?", "", {
          confirmButtonText: "确认删除",
          cancelButtonText: "取消",
          center: true
        })
          .then(() => {
            if (role.count == 0) {
              let data = {
                roleId: role.roleId
              };
              console.log(data);
              deleteRole(data)
                .then(res => {
                  this.$message({
                    type: "success",
                    message: "删除成功!"
                  });
                  this.getRoleFun();
                })
                .catch(error => {
                  this.$message({
                    type: "error",
                    message: "删除失败"
                  });
                });
            } else {
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      } else {
        this.$refs.notClose.init();
      }
    },
    // 点击查看权限
    lookLimit(roleId) {
      this.$refs.limit.init(roleId);
    }
  }
};
</script>

<style lang="scss" scoped>
@include admin;
</style>
